import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const TenantContext = createContext();

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }) => {
  const { tenantName } = useParams();
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (tenantName) {
      // For now, we'll just set the tenant from URL params
      // In the future, this could validate the tenant with API
      setTenant({
        name: tenantName,
        displayName: tenantName.charAt(0).toUpperCase() + tenantName.slice(1),
        id: null // Will be set after API validation
      });
      setLoading(false);
    } else {
      setError('No tenant specified in URL');
      setLoading(false);
    }
  }, [tenantName]);

  const value = {
    tenant,
    tenantName,
    loading,
    error,
    setTenant
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
}; 